import React from 'react';
import '../../App.css'
import MentionsLegales from '../MentionsLegales';

function MentionsPage() {
    return (
        <>
            <MentionsLegales />
        </>
    )
}

export default MentionsPage;